

<app-navbar></app-navbar>
<div class=" pt-36    ">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>